module.exports = __webpack_public_path__ + "media/site/images/home_case_studies/home-case-study-ekanban@2x-3e132cdcc914ad8da209870897ab7254.png";